import { jsx as B } from "react/jsx-runtime";
import { useRef as d, useEffect as c } from "react";
import { v as S } from "../../videojsVttThumbnails-CG9lE1qD.js";
import { c as Q } from "../../index-BkL7vJ-E.js";
import { s as j } from "../../Player.module-DcPK3CRl.js";
import { usePlayerContext as x } from "../../hook/usePlayerContext.js";
const N = ({
  onReady: I,
  qualityValidate: m,
  sendTrack: h,
  coverUrl: v,
  aspectRatio: y,
  vtt: l,
  sendUserWatch: w,
  fullscreenOnPlay: L,
  ...a
}) => {
  const { playerRef: r, setInitialed: g, forceStopped: q } = x(), b = d(null), i = d(), p = d(null), _ = d(0), E = d(), P = d(null), C = d(null), D = () => S.browser.IS_ANDROID || S.browser.IS_IOS;
  return c(() => {
    var t;
    if (!b.current) return () => {
    };
    const e = document.createElement("video-js");
    return e.classList.add("vjs-big-play-centered"), b.current.appendChild(e), r.current = S(
      e,
      {
        bigPlayButton: !0,
        controls: !0,
        fluid: !0,
        html5: {
          nativeAudioTracks: !1,
          nativeVideoTracks: !1,
          vhs: { overrideNative: !0 }
        },
        poster: v,
        aspectRatio: y,
        ...a
      },
      () => {
        console.log("academy player is ready..."), I && I(r.current), g(!0);
      }
    ), i.current = r.current.qualityLevels(), i.current.on("change", function() {
      var u, o;
      const n = (o = i.current) == null ? void 0 : o[(u = i.current) == null ? void 0 : u.selectedIndex];
      n && (P.current = n.height ?? null, C.current = `${n.width}*${n.height}`);
    }), (t = r.current) == null || t.on("error", (n) => {
      console.error("academy player error:", n);
    }), r.current.hlsQualitySelector({ displayCurrentQuality: !0 }), D() || r.current.seekButtons({
      forward: 15,
      back: 15
    }), r.current.mobileUi(), r.current.landscapeFullscreen({
      fullscreen: {
        enterOnRotate: !0,
        exitOnRotate: !0,
        alwaysInLandscapeMode: !0,
        iOS: !0
      }
    }), () => {
      g(!1);
    };
  }, []), c(() => {
    var e;
    !r.current || a.autoplay === void 0 || ((e = r.current) == null ? void 0 : e.options_.autoplay) === a.autoplay || r.current.autoplay(a.autoplay);
  }, [a.autoplay]), c(() => {
    var e, t;
    !r.current || ((e = r.current) == null ? void 0 : e.options_.sources) === a.sources || (t = r.current) == null || t.src(a.sources ?? []);
  }, [a.sources]), c(() => {
    var e, t;
    !r.current || ((e = r.current) == null ? void 0 : e.options_.poster) === a.poster || (t = r.current) == null || t.poster(v ?? "");
  }, [v]), c(() => {
    var e, t;
    !r.current || ((e = r.current) == null ? void 0 : e.options_.aspectRatio) === y || !y || (t = r.current) == null || t.aspectRatio(y);
  }, [y]), c(() => () => {
    var e;
    !r.current || !((e = r.current) != null && e.isDisposed()) || (r.current.dispose(), r.current = null);
  }, []), c(() => {
    var t, n, u;
    if (!q || !r.current) return () => {
    };
    const e = () => {
      var o;
      (o = r.current) == null || o.pause();
    };
    return e(), (t = r.current) == null || t.controlBar.hide(), (n = r.current) == null || n.bigPlayButton.hide(), (u = r.current) == null || u.on("play", e), () => {
      var o;
      (o = r.current) == null || o.off("play", e);
    };
  }, [q, r.current]), c(() => {
    if (!m || !r.current || !i.current) return () => {
    };
    const e = "hamrah-player__quality--disabled", t = () => {
      var u, o, s;
      (((s = (o = (u = r.current) == null ? void 0 : u.hlsQualitySelector) == null ? void 0 : o._qualityButton) == null ? void 0 : s.items) ?? []).forEach((f) => {
        f.item.value !== "auto" && !m(f.item.value) && f.el_.classList.add(e);
      });
    };
    return i.current.on("addqualitylevel", t), () => {
      var u, o, s, f;
      (u = i.current) == null || u.off("addqualitylevel", t), (((f = (s = (o = r.current) == null ? void 0 : o.hlsQualitySelector) == null ? void 0 : s._qualityButton) == null ? void 0 : f.items) ?? []).forEach((k) => {
        k.el_.classList.remove(e);
      });
    };
  }, [r.current, m, a.sources]), c(() => {
    if (!r.current) return () => {
    };
    const e = () => {
      p.current || (p.current = (/* @__PURE__ */ new Date()).toISOString()), E.current = setInterval(() => {
        _.current += 1;
      }, 1e3);
    }, t = () => {
      clearInterval(E.current);
    };
    return r.current.on("play", e), r.current.on("pause", t), () => {
      var n, u;
      (n = r.current) == null || n.off("play", e), (u = r.current) == null || u.off("pause", t);
    };
  }, [r.current]), c(() => {
    if (!h) return;
    const e = () => (p.current && (h(p.current, _.current, P.current), p.current = null), null);
    return window.addEventListener("beforeunload", e), () => {
      e(), window.removeEventListener("beforeunload", e);
    };
  }, [h]), c(() => {
    if (!w) return;
    const e = () => {
      var n, u, o, s;
      const t = C.current ?? ((n = r.current) != null && n.videoWidth() ? `${(u = r.current) == null ? void 0 : u.videoWidth()}*${(o = r.current) == null ? void 0 : o.videoHeight()}` : "unknown");
      return (((s = r.current) == null ? void 0 : s.currentTime()) ?? 0) > 1 && w(_.current, r.current.currentTime(), t), null;
    };
    return window.addEventListener("beforeunload", e), () => {
      e(), window.removeEventListener("beforeunload", e);
    };
  }, [w]), c(() => {
    if (!(!(l != null && l.desktop) && !(l != null && l.mobile)))
      return r.current.vttThumbnails({
        src: D() && l.mobile || l.desktop
      }), () => {
      };
  }, [l]), c(() => {
    if (!L || !r.current) return;
    const e = () => {
      var t;
      (t = r.current) == null || t.requestFullscreen();
    };
    return r.current.on("play", e), () => {
      var t;
      (t = r.current) == null || t.off("play", e);
    };
  }, [L, r.current]), /* @__PURE__ */ B(
    "div",
    {
      className: Q(j.videoPlayerContainer, "hamrah-player__video-player"),
      ref: b,
      "data-vjs-player": ""
    }
  );
};
export {
  N as default
};
